export default __webpack_public_path__ + "static/media/batuk.121019a4.png";